import { render } from "./ResourceDetailView.vue?vue&type=template&id=54b9c052&ts=true"
import script from "./ResourceDetailView.vue?vue&type=script&lang=ts"
export * from "./ResourceDetailView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__